<template>
    <div>
        <div class="coupon_content" v-if="couponData.Items.length > 0">
            <div class="single_coupon_content"
            @click="clickCoupon(index)"
            v-for="(item,index) in couponData.Items" :key="index">
                <div class="single_coupon_content_flex">
                    <div class="value_content">
                        <span class="value_text1">{{item.FaceValue}}</span>
                        <span class="value_text2">元</span>
                    </div>
                    <div class="whiteSplit"></div>
                    <div class="fund_content">
                        <div class="fund_content_row">
                            <img class="fund_content_image" :src='item.HeaderImgPath'/>
                            <span class="fund_content_name">{{item.CFHName}}</span>
                        </div>
                        <div class="fund_content_row">
                            <span class="fund_content_msg">{{item.UseMsg}}</span>
                        </div>
                    </div>
                </div>
                <div v-if="couponData.Items.length == 1" class="single_coupon_content_flex">
                    <div style="align-items: center;">
                        <div class="white_up_cycle"></div>
                        <div class="white_cycle_split"></div>
                        <div class="white_down_cycle"></div>
                    </div>
                    <span class="fund_content_one_text"
                    >{{ item.UseStatus == false ? '立即使用' : '立即领取'}}</span>
                </div>
                <div class="single_coupon_mask" v-if="item.UseStatus == false"></div>
            </div>
            <div v-if="couponData.HasMore == true" @click="goNextPage">
                <span class="all_red_pocket">全部红包</span>
            </div>
        </div>
        <div class="modulesplit" v-if="couponData.Items.length > 0"></div>
    </div>
</template>

<script>
import Vue from 'vue';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  props: {
    couponData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
    };
  },
  methods: {
    updateStateInGet() {
      if (this.couponData) {
        if (this.couponData.Items) {
          Vue.set(this.couponData.Items[0], 'UseStatus', false);
        }
      }
    },
    goNextPage() {
      const linkto = this.couponData.MoreLink;
      const { LinkType, LinkTo } = linkto;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
    },
    clickCoupon(couponIndex) {
      this.$emit('showCouponClick', couponIndex, this.couponData.Items[couponIndex]);
    },
  },
};
</script>

<style scoped>
.coupon_content{
    width: 100%;
    height: 140px;
    display: flex;
    align-items: center;
    flex-direction: row;
    background-color: #FFFFFF;
}

.single_coupon_content{
    /* width: 329px; */
    height: 100px;
    border-radius: 4px;
    margin-left: 30px;
    margin-right: 30px;
    display: flex;
    flex: 1;
    flex-direction: row;
    position: relative;
    justify-content: space-between;
    background-image: linear-gradient(to bottom,#FF6D0B, #EF4916);
}

.single_coupon_content_flex{
    display: flex;
    flex-direction: row;
}

.single_coupon_mask{
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background-color: rgba(255,255,255,0.5);
}

.value_content{
    display: flex;
    flex-direction: row;
    /* width: 112px; */
    align-items: flex-end;
}

.value_text1{
    font-family: PingFangSC-Regular;
    font-size: 68px;
    color: #FFD41D;
    letter-spacing: 0;
    line-height: 72px;
    margin: 16px 6px 16px 20px;
}

.value_text2{
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #FFD41D;
    letter-spacing: 0;
    line-height: 68px;
    margin-right: 20px;
}

.whiteSplit{
    height: 68px;
    width: 1px;
    margin: 16px 0px 16px 0px;
    border: 2px solid #FFA068;
}

.fund_content{
    /* width: 275px; */
    margin: 20px;
    min-width: 230px;
}

.fund_content_row{
    display: flex;
    flex-direction: row;
}

.fund_content_image{
    width: 32px;
    height: 32px;
    border-radius: 16px;
}

.fund_content_name{
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #FFFFFF;
    margin-left: 10px;
}

.fund_content_msg{
    font-family: PingFangSC-Regular;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 24px;
    margin-top: 5px;
}

.all_red_pocket{
    background: rgba(255,100,52,0.10);
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #FF6434;
    width: 100px;
    height: 100px;
    padding: 20px;
    line-height: 28px;
    margin-left: 20px;
    margin-right: 10px;
    text-align: center;
}

.modulesplit{
    height: 30px;
    background-color: rgb(245, 245, 245);
}

.fund_content_one_text{
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #FFD41D;
    letter-spacing: 0;
    line-height: 68px;
    margin: 16px 30px 16px 20px;
    text-align: right;
}

.white_up_cycle{
    height: 16px;
    width: 16px;
    margin-top: -8px;
    border-radius: 8px;
    background: white;
}
.white_down_cycle{
    height: 16px;
    width: 16px;
    margin-bottom: 8px;
    border-radius: 8px;
    background: white;
}
.white_cycle_split{
    height: 84px;
    width: 1px;
    margin-left: 7px;
    border: 1px dashed #FFA068;
}
</style>
